__turbopack_context__.v({
  "autoSuggest__mobileContainer": "auto-suggest-module-scss-module__odGBJG__autoSuggest__mobileContainer",
  "autoSuggest__mobileContainer__expanded": "auto-suggest-module-scss-module__odGBJG__autoSuggest__mobileContainer__expanded",
});
